import React, { type FC } from 'react'
import { createPortal } from 'react-dom'

import { useIntl } from 'react-intl'

import { useRecoilCallback, useRecoilValue } from 'recoil'

import styled from '@emotion/styled'

import {
  Checkbox,
  ContextMenu,
  Flex,
  LINK_VARIANT_EXTRALIGHT,
  Link,
  makeButtonWithMenu,
} from 'mailup-web-components'

import IconAngleDownSolid from 'Components/icons/IconAngleDownSolid'

import {
  bulkSelectAllCallback,
  bulkSelectNoneCallback,
  bulkSelectVisibleCallback,
} from '../recoil/callbacks'
// import {
//   bulkSelectAllCallback,
//   bulkSelectNoneCallback,
//   bulkSelectVisibleCallback,
// } from 'Pages/RecipientsList/recoil/callbacks/bulk'
import {
  isSelectAllCheckedState,
  isSelectAllIndeterminateState,
  isSelectRecipientDisabled,
} from '../recoil/state'

const StyledChecbox = styled(Checkbox)`
  pointer-events: none;
.c-checkbox__label:before {
  margin-right: 0
  }
`

const TriggerComponent: FC = () => {
  const checked = useRecoilValue(isSelectAllCheckedState)
  const disabled = useRecoilValue(isSelectRecipientDisabled)
  const isIndeterminate = useRecoilValue(isSelectAllIndeterminateState)

  const handleChange = (e: any): void => {
    e.stopPropagation()
    e.preventDefault()
  }

  return (
    <Flex alignItems="center">
      <StyledChecbox
        checked={checked}
        disabled={disabled}
        isIndeterminate={isIndeterminate}
        data-mu-test="select-all"
        onChange={handleChange}
      />
      <Link variant={LINK_VARIANT_EXTRALIGHT} alignContent>
        <IconAngleDownSolid width="11px" height="12px" />
      </Link>
    </Flex>
  )
}
// const handleAll = () => {
//   bulkSelectAll()
// }

const MenuComponent = () => {
  const intl = useIntl()
  const bulkSelectAll = useRecoilCallback(bulkSelectAllCallback, [])
  const bulkSelectVisible = useRecoilCallback(bulkSelectVisibleCallback, [])
  const bulkSelectNone = useRecoilCallback(bulkSelectNoneCallback, [])

  const handleVisible = () => {
    bulkSelectVisible()
  }

  const handleNone = () => {
    bulkSelectNone()
  }

  const items = [
    {
      label: intl.formatMessage({
        id: 'Load.RecipientsList.BatchSelectAll',
      }),
      value: 'all',
      onClick: () => bulkSelectAll(),
    },
    {
      label: intl.formatMessage({
        id: 'Load.RecipientsList.BatchSelectVisible',
      }),
      value: 'visible',
      onClick: handleVisible,
    },
    {
      label: intl.formatMessage({
        id: 'Load.RecipientsList.BatchSelectNone',
      }),
      value: 'none',
      onClick: handleNone,
    },
  ]
  return <ContextMenu items={items} />
}

const ButtonWithMenu = makeButtonWithMenu(TriggerComponent, MenuComponent)

interface ItemSelectAllProps {
  className?: string
}

const ItemSelectAll: FC<ItemSelectAllProps> = ({ className }) => {
  return <ButtonWithMenu className={className} direction="down" />
}

// export default ItemSelectAll

const StyledItemSelectAll = styled(ItemSelectAll)`
  transition: background-color 0.2s ease;
  position: relative;
  top:-3px;

  padding: 3px 4px 3px 3px;
  margin: 0 0 0 -3px;

  border-radius: 4px;

  cursor: pointer;

  &:hover {
    background-color: #eeeeee;
  }

  & .c-checkbox__label::before {
    margin-right: 0;
  }
`

export default StyledItemSelectAll
